module.exports = __webpack_public_path__ + "static/media/1D.b23da7c3.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Assets/Files/1D.pdf
// module id = 80
// module chunks = 0